import { Component, h } from "preact";

import { Icon } from "../../Icon";

export function StarIcon(rest) {
  return (
    <Icon {...rest}>
      <path d="M25 2L31.6126 17.8986L48.7764 19.2746L35.6994 30.4764L39.6946 47.2254L25 38.25L10.3054 47.2254L14.3006 30.4764L1.22359 19.2746L18.3874 17.8986L25 2Z" />
    </Icon>
  );
}
